import { useAtomValue } from 'jotai';
import { variationsAtom } from '../atoms/seriesAtoms';

const useVariations = () => {
    const variations = useAtomValue(variationsAtom);
    return [...variations].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
};

export default useVariations;
